import {
  ActivityFileTypeEnum,
  ActivityMediaInterface,
  FileUploadInterface,
  ImageResolutionInterface,
  OrganizationFileTypeEnum,
} from '@sport-activities/sdk';

import {
  ActivityMediaResolutionEnum,
  OrganizationMediaResolutionEnum,
} from '~/organizer/shared/enums/media-resolution.enum';

export const mediaResolutions: Record<
  ActivityMediaResolutionEnum | OrganizationMediaResolutionEnum,
  ImageResolutionInterface
> = {
  // 3:2
  [ActivityMediaResolutionEnum.HP_CARD]: {
    width: 270,
    height: 180,
  },
  //  3:2
  [ActivityMediaResolutionEnum.CARD]: {
    width: 384,
    height: 256,
  },
  //  3:2
  [ActivityMediaResolutionEnum.LARGE_CARD]: {
    width: 354,
    height: 236,
  },
  // 3:2
  [ActivityMediaResolutionEnum.LARGE]: {
    width: 618,
    height: 412,
  },
  // 1:1
  [ActivityMediaResolutionEnum.ICON]: {
    width: 100,
    height: 100,
  },
  // 1:1
  [OrganizationMediaResolutionEnum.LOGO]: {
    width: 200,
    height: 200,
  },
};

export function getMediaUrlByIdentifier(
  medias: ActivityMediaInterface[],
  identifier: string,
  mediaResolution: ActivityMediaResolutionEnum
): string {
  const foundMedia = medias?.find((media) => media.identifier === identifier);

  if (!foundMedia) {
    return '';
  }

  return pickResolutionUrl<ActivityFileTypeEnum>(foundMedia, mediaResolution);
}

export function getMediaUrlByType<T>(
  medias: FileUploadInterface<T>[],
  mediaType: T,
  mediaResolution: T extends ActivityFileTypeEnum
    ? ActivityMediaResolutionEnum
    : OrganizationMediaResolutionEnum
): string {
  // Pick the first media with the given type, we don't return multiple URLs for now
  const foundMedia = medias?.find((media) => media.types.includes(mediaType));

  if (!foundMedia) {
    return '';
  }

  return pickResolutionUrl(foundMedia, mediaResolution);
}

function pickResolutionUrl<T>(
  media: FileUploadInterface<T>,
  mediaResolution: T extends ActivityFileTypeEnum
    ? ActivityMediaResolutionEnum
    : OrganizationMediaResolutionEnum
): string {
  // Find resolution which matches both width and height and return its URL,
  // or fallback on original media URL if no resolution found
  return (
    media.resolutions?.find((resolution) => {
      return (
        resolution.height === mediaResolutions[mediaResolution]?.height &&
        resolution.width === mediaResolutions[mediaResolution]?.width
      );
    })?.url || media.url
  );
}

export function buildFormDataForMediaUpload(
  media: Blob,
  name: string,
  fileTypes: (ActivityFileTypeEnum | OrganizationFileTypeEnum)[],
  resolutions?: ImageResolutionInterface[]
): FormData {
  const formData = new FormData();
  formData.append('file', media, name);

  fileTypes.forEach((fileType) => {
    formData.append('types[]', fileType);
  });

  resolutions?.forEach((resolution, index) => {
    formData.append(
      `resolutions[${index}][height]`,
      resolution.height.toString()
    );
    formData.append(
      `resolutions[${index}][width]`,
      resolution.width.toString()
    );
  });

  return formData;
}

export function getRatio(
  mediaResolution: ActivityMediaResolutionEnum | OrganizationMediaResolutionEnum
): number {
  const resolution = mediaResolutions[mediaResolution];

  return resolution.width / resolution.height;
}
